import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PatientSubscriptionsDataService } from 'app/@core/backend/common/services/CalorieFriend/patient-subscriptions-data.service';
import { PatientSubscriptionsFilter } from 'app/@core/interfaces/common/CalorieFriend/patient-subscription';

@Component({
  selector: 'app-patient-view-subscriptions',
  templateUrl: './patient-subscriptions.component.html',
  styleUrls: ['./patient-subscriptions.component.scss'],
})
export class PatientSubscriptionsComponent implements OnInit {
  @Input('patientGuid')
  PatientGuid: string;

  constructor(
    private subscriptionService: PatientSubscriptionsDataService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {}

  /**
   * !This function should be arrow functions
   * @param filter filter for querying invoices
   * @returns
   */
  loadSubscriptions = (filter: PatientSubscriptionsFilter) => {
    //const guid = this.patientStore.patient().patientGuid;
    return this.subscriptionService.listForPatient(this.PatientGuid, {
      ...filter,
    });
  };

  onView = ({ id = 0 }) => {
    //console.log(['/', 'billing', this.PatientGuid, 'invoices', id]);
    this.router.navigate(['subscriptions',id], { relativeTo: this.route });
  };
}
